import { GET_POSTS_BY_ID } from './constants';

export interface PostsResponse {
    status: string;
    profile?: DocProfile;
    posts?: PostsEntity[] | null;
    alldoctors?: DocProfile[] | null;
}
export interface DocProfile {
    _id: string;
    created_at: string;
    profile: Profile1;
    updated_at: string;
}
export interface Profile1 {
    personal: Personal;
    professional: Professional;
}
export interface Personal {
    name: Name;
    phone: Phone;
    email: string;
    gender: string;
    dob: string;
    pic: string;
    pic_small?: string;
}
export interface Name {
    f: string;
    l: string;
}
export interface Phone {
    code: string;
    value: string;
}
export interface Professional {
    registrations: Registrations;
    about: string;
    telemedicine: Telemedicine;
    degree?: DegreeEntityOrSpecialityEntityOrClinicsEntityOrMajorSpeciality[] | null;
    signature_text: string;
    header_text: string;
    major_speciality?: DegreeEntityOrSpecialityEntityOrClinicsEntityOrMajorSpeciality;
    speciality?: DegreeEntityOrSpecialityEntityOrClinicsEntityOrMajorSpeciality[] | null;
    signature: string;
    username: string;
    clinics?: DegreeEntityOrSpecialityEntityOrClinicsEntityOrMajorSpeciality[] | null;
    default_clinic: string;
}
export interface Registrations {
    council: string;
    id: string;
    medical_id: string;
    year: string;
}
export interface Telemedicine {
    flag: boolean;
    price: Price;
}
export interface Price {
    c: string;
    v: number;
}
export interface DegreeEntityOrSpecialityEntityOrClinicsEntityOrMajorSpeciality {
    name: string;
    id: string;
}
export interface PostsEntity {
    _id: string;
    type: string;
    meta: Meta;
    docid: string;
    posttype: string;
    created_at: string;
    updated_at: string;
    patient?: {
        name?: string;
    };
}
export interface Meta {
    display: Display;
    sa_id?: string | null;
}
export interface Display {
    title: string;
    description: string;
    link: string;
    file_type?: string;
}

export default (postId: string): Promise<PostsResponse> =>
    fetch(GET_POSTS_BY_ID(postId)).then((r) => {
        if (r.status === 200) {
            return r.json();
        } else {
            throw new Error('failed');
        }
    });
